import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradeList, TradeListResponse } from 'services/api/conversation';
import { OrderQueryParams } from './useOrderList';
import { queries } from 'services/queries';

interface OrderUpdateParams {
  internalBuyerId: string;
  storeId: string;
  tunnelAccountId: string;
  externalTradeId: string;
}
export const useOrderUpdate = ({
  queryParams,
  onSuccess,
  onError,
}: {
  queryParams?: OrderQueryParams;
  onSuccess?: (newOrder?: Conversation.Trade.Vo) => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (params: OrderUpdateParams) => {
      const { internalBuyerId, storeId, tunnelAccountId, externalTradeId } = params;
      return tradeList({
        page_no: 1,
        page_size: 1,
        internal_buyer_id: internalBuyerId,
        internal_store_id: storeId,
        tunnelAccountId: tunnelAccountId,
        external_trade_ids: externalTradeId,
      }).then((res) => {
        return res?.tradeList?.[0];
      });
    },
    onSuccess: (newOrder?: Conversation.Trade.Vo) => {
      if (queryParams && newOrder) {
        const queryKey = queries.orders.list(queryParams).queryKey;

        queryClient.setQueryData(queryKey, (oldData: TradeListResponse | undefined) => {
          if (!oldData?.tradeList) return oldData;

          return {
            ...oldData,
            tradeList: oldData.tradeList.map((order: Conversation.Trade.Vo) => {
              if (order.internalTradeId !== newOrder.internalTradeId) return order;

              return {
                ...order,
                ...newOrder,
              };
            }),
          };
        });
      }
      onSuccess?.(newOrder);
    },
    onError,
  });

  return {
    mutateAsync,
    isLoading,
  };
};
